import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const InputTextEditor = ({value, onChange}) => {
  const handleChange = value => {
    onChange(value);
  };

  return <ReactQuill value={value} onChange={handleChange} />;
};

export default InputTextEditor;
